import Image from './BazarImage';
import { Paragraph } from './Typography';
import { Box, Container, Grid, styled, Typography } from '@mui/material';
import { assets, stringConstants, routerUrls } from 'constants';
import { Link } from 'react-router-dom';
import React from 'react';
import FlexBox from './FlexBox';

import { useContext } from 'react';
import { GlobalContext } from 'context/GlobalState';
import { strings } from 'localisation';
import SocialLinks from './SocialLinks';
import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const StyledLink = styled('a')(({ theme }) => ({
  position: 'relative',
  display: 'block',
  padding: '0.3rem 0rem',
  color: theme.palette.text.secondary,
  cursor: 'pointer',
  borderRadius: 4,
  textDecoration: 'none',
  '&:hover': {
    color: theme.palette.gold.text
  }
}));

const FooterBazar = () => {
  const { lang } = useContext(GlobalContext);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const aboutLinks = [
    {
      pageName: strings[lang].returnPage,
      pageLink: routerUrls.returnInfo
    },
    {
      pageName: strings[lang].deliveryPage,
      pageLink: routerUrls.deliveryInfo
    },
    {
      pageName: strings[lang].paymentTypesPage,
      pageLink: routerUrls.paymentMethods
    },
    {
      pageName: strings[lang].usefulInformationPage,
      pageLink: routerUrls.usefulInfo
    },
    {
      pageName: strings[lang].sizeTables,
      pageLink: routerUrls.sizingGuides
    }
  ];

  const customerCareLinks = [
    {
      pageName: strings[lang].blogPage,
      pageLink: routerUrls.blog
    },
    {
      pageName: strings[lang].returnFormPage,
      pageLink: routerUrls.returnForm
    },
    {
      pageName: strings[lang].privacyPage,
      pageLink: routerUrls.privacyPolicy
    },
    {
      pageName: strings[lang].contactsPage,
      pageLink: routerUrls.contacts
    },
    {
      pageName: strings[lang].termsAndConditionsPage,
      pageLink: routerUrls.termsAndConditions
    }
  ];
  return (
    <footer>
      <Box
        bgcolor="background.paper"
        sx={{ mt: 5, borderTop: '1px solid', borderColor: 'divider' }}>
        <Container
          sx={{
            p: '1rem',
            color: 'text.primary'
          }}>
          <Box py={isMobile ? 3 : 10} overflow="hidden">
            <Grid container spacing={3}>
              <Grid item lg={4} md={6} sm={6} xs={12}>
                <Image height={58} width={183} mb={2.5} src={assets.logo} alt="logo" />
                <Paragraph mb={2.5} color="text.secondary" style={{ fontSize: 15 }}>
                  {strings[lang].footerInfo}
                </Paragraph>
              </Grid>

              <Grid item lg={2} md={6} sm={6} xs={12}>
                <Typography
                  variant="overline"
                  component="div"
                  mb={2.5}
                  sx={{ fontWeight: 700, color: 'gold.text' }}>
                  {strings[lang].infoTabLabel}
                </Typography>

                <>
                  {aboutLinks.map((item, idx) => (
                    <Link
                      to={item.pageLink}
                      style={{ color: 'inherit', textDecoration: 'none' }}
                      key={idx}>
                      <StyledLink>
                        <Typography>{item.pageName}</Typography>
                      </StyledLink>
                    </Link>
                  ))}
                </>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={12}>
                <Typography
                  variant="overline"
                  component="div"
                  mb={2.5}
                  sx={{ fontWeight: 700, color: 'gold.text' }}>
                  {strings[lang].helpTabLabel}
                </Typography>

                <>
                  {customerCareLinks.map((item, idx) => (
                    <Link
                      to={item.pageLink}
                      style={{ color: 'inherit', textDecoration: 'none' }}
                      key={idx}>
                      <StyledLink>
                        <Typography>{item.pageName}</Typography>
                      </StyledLink>
                    </Link>
                  ))}
                </>
              </Grid>

              <Grid item lg={3} md={6} sm={6} xs={12}>
                <Typography
                  variant="overline"
                  component="div"
                  mb={2.5}
                  sx={{ fontWeight: 700, color: 'gold.text' }}>
                  {strings[lang].contactUsTabLabel}
                </Typography>
                <Link
                  to={routerUrls.contactForm}
                  style={{ color: 'inherit', textDecoration: 'none' }}>
                  <Typography py={0.6} sx={{ color: 'text.secondary' }}>
                    {strings[lang].contactForm}
                  </Typography>
                </Link>
                <Box py={0.6} color="text.secondary">
                  Email: {stringConstants.email}
                </Box>
                <Box py={0.6} mb={2} color="text.secondary">
                  WhatsApp/Viber: {stringConstants.phone}
                </Box>

                <SocialLinks />

                <FlexBox className="flex" mx={-0.625}></FlexBox>
              </Grid>
            </Grid>
          </Box>
          <Typography align="center" sx={{ color: 'text.disabled', fontSize: '14px' }}>
            Copyright © GoToBed {new Date().getFullYear()}. Всички права запазени.
          </Typography>
        </Container>
      </Box>
    </footer>
  );
};

export default FooterBazar;
